import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TipoObjeto } from '../../models/enums';
import { ICatalogoResponse } from '../../interfaces/response/ICatalogoResponse';
import { IObject } from 'src/app/state/objects/objects.models';
import { ICoverageDetails } from 'src/app/state/coverages/coverages.models';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { ICoverageInfoScreen } from '../../interfaces/response/ICoverageInfoScreenResponse.interface';
import { first } from 'rxjs/operators';


export interface queryObjectsCotization {
  idCotizacion?: number;
  UIDCotizacion?: string;
  idPoliza?: number;
}


@Injectable({
  providedIn: 'root'
})
export class ObjetosService {

  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiProducto}`;
  url: string;


  /**
   * Set the url property
   */
  constructor(
    private http: HttpClient,
  ) {
    this.url = this.baseUrl + this.apiUrl;
  }

  /** 
   * Get the objects related to a category and tipo objeto
   * @param idCategoria The idCategory to filter
   * @param tipoObjeto The Tipo objeto to filter
   * @returns An observable with the array of objects found
   */
  getObjetos(idCategoria: number, tipoObjeto: TipoObjeto)  { 
    return this.http.get<ICatalogoResponse<IObject[]>>(`${this.url}/GetObjectsByIdCategoryandTypeObject/${idCategoria}/objetos/${tipoObjeto}`).pipe(first());
  }
  
  getObjects(idEntidad: number) {
    return this.http.get<ICatalogoResponse<IObject[]>>(`${this.url}/GetObjectsPartners/${idEntidad}`).pipe(first())
  }
  getCoverageInfoText(aliasPantalla: string, idProducto: number, proxy: boolean = false){

    let url = encodeURI(`${this.url}/GetCoveragesInfoText/${aliasPantalla}/IdProduct/${idProducto}`);
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Pantallas/pantallaInfo?AliasPantalla=${aliasPantalla}&IdProducto=${idProducto}`;

    return this.http.get<ICatalogoResponse<ICoverageDetails[]>>(url).pipe(first())
  }

  getCoverageInfoTextByPantallaInfo(aliasPantallaInfo: string){
    return this.http.get<ICatalogoResponse<ICoverageDetails[]>>(`${this.url}/GetCoverageInfoTextByScreenInfo/${aliasPantallaInfo}`).pipe(first())
  }
  
  GetCoverageInfoScreenByIdProduct( aliasPantalla:string, idProducto:number){
    return this.http.get<IHttpResponse<ICoverageInfoScreen[]>>(`${this.url}/GetCoverageInfoScreenByIdProduct/${aliasPantalla}/idProducto/${idProducto}`)
  }

  getObjetsCotizationPolicy( data?: queryObjectsCotization, proxy: boolean = false){
    let query;

    if(data){
      query = Object.keys(data)
        .map((key) => `${key}=${data[key]}`)
        .join('&');
    }

    let url = `${this.url}/GetObjetsCotizationPolicy/?${query}`;
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}${this.apiUrl}/ObjetosCotizacionPoliza/ObjetosCotizacionPoliza?${query}`;

    return this.http.get<any>(url);

  }
  getCobertsCotizationPolicy( data?: queryObjectsCotization){
    let query;

    if(data){
      query = Object.keys(data)
        .map((key) => `${key}=${data[key]}`)
        .join('&');
    }

    return this.http.get<any>(`${this.url}/GetCoveragesQuotationPolicy/?${query}`)
  }

}
